import { Component, OnInit } from '@angular/core';
import Typed from 'typed.js';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  greetUser: string;
  constructor() { }

  ngOnInit(): void {
    new Typed('.greet-element', {
      strings: ["Full Stack Developer...", "Former NCC Cadet...", "Open Source Contributor...", "CoderDojo Mentor...", "Speaker...", "Tech Lover...", "Sport Lover..."],
      typeSpeed: 100,
      backSpeed: 100,
      loop: true
    });

    let currentdate: any = new Date();
    let curHr = currentdate.getHours();
    this.greetUser = this.greetUserBySession(curHr);
  }

  greetUserBySession(curHr) {
    if (curHr < 12) {
      return 'Good Morning...!';
    } else if (curHr < 18) {
      return 'Good Afternoon...!';
    } else {
      return 'Good Evening...!';
    }
  }

}